import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useAppSelector } from "Redux/hooks";
import { selectIsHalfPage, selectTableOfContent } from "Redux/appSlice";

type Props = {
  direction: string;
  onClick: (direction: string) => void;
  newClassName?: string;
  extraClassName?: string;
  id?: string;
  label?: string;
};

/*
  @function NavigatorChevron
  navigator button
  @params direction {string} - direction of Button
  @params onClick {function} - called on click
  @params newClassName {string} - override className
  @returns {React.Node}
*/
export default function NavigatorChevron({
  direction,
  onClick,
  newClassName,
  extraClassName,
  id,
  label,
}: Props) {
  const directionStyle = direction === "up" ? "top-16" : "bottom-16 rotate-180";
  const tableOfContent = useAppSelector(selectTableOfContent);
  const isHalfPage = useAppSelector(selectIsHalfPage);
  return (
    <button
      id={id}
      className={
        newClassName
          ? `${newClassName} ${directionStyle} translate-y-1/2 translate-x-1/2 cursor-pointer`
          : `m-2 absolute fixed translate-y-1/2  translate-x-1/2 z-10 ${extraClassName} ${
              tableOfContent && isHalfPage ? "right-3/4" : "right-1/2"
            } ` + directionStyle
      }
      onClick={() => onClick(direction)}
      aria-label={label}
    >
      <FontAwesomeIcon
        className="cursor-pointer"
        icon={faChevronUp}
        size="2x"
        color="#A6A6A6"
        title={label}
      />
    </button>
  );
}
